import darkBusIconSquare from '../../../../../../assets/icons/transport-modes/bus-square-filled-gray-900.svg';
import darkBusIcon from '../../../../../../assets/icons/transport-modes/bus-default-gray-900.svg';
import darkFerryIconSquare from '../../../../../../assets/icons/transport-modes/ferry-square-filled-gray-900.svg';
import darkFerryIcon from '../../../../../../assets/icons/transport-modes/ferry-default-gray-900.svg';
import darkTaxiIconSquare from '../../../../../../assets/icons/transport-modes/taxi-square-filled-gray-900.svg';
import darkTaxiIcon from '../../../../../../assets/icons/transport-modes/taxi-default-gray-900.svg';
import darkTrainIconSquare from '../../../../../../assets/icons/transport-modes/train-square-filled-gray-900.svg';
import darkTrainIcon from '../../../../../../assets/icons/transport-modes/train-default-gray-900.svg';
import darkTramIconSquare from '../../../../../../assets/icons/transport-modes/tram-square-filled-gray-900.svg';
import darkTramIcon from '../../../../../../assets/icons/transport-modes/tram-default-gray-900.svg';
import darkWalkIconSquare from '../../../../../../assets/icons/transport-modes/walk-square-filled-gray-900.svg';
import darkWalkIcon from '../../../../../../assets/icons/transport-modes/walk-default-gray-900.svg';
import darkBikeIconSquare from '../../../../../../assets/icons/transport-modes/bike-square-filled-gray-900.svg';
import darkBikeIcon from '../../../../../../assets/icons/transport-modes/bike-default-gray-900.svg';
import { TransportMode } from '../../../../../models/transport-mode.enum';
import { TransportModeHelper } from '../../../../../helpers/transport-mode.helper';
import DataUrlHelper from '../../../../../helpers/data-url.helper';

const iconSources: Partial<Record<TransportMode, { square: string; default: string }>> = {
  [TransportMode.train]: { square: DataUrlHelper.encode(darkTrainIconSquare), default: DataUrlHelper.encode(darkTrainIcon) },
  [TransportMode.bus]: { square: DataUrlHelper.encode(darkBusIconSquare), default: DataUrlHelper.encode(darkBusIcon) },
  [TransportMode.tram]: { square: DataUrlHelper.encode(darkTramIconSquare), default: DataUrlHelper.encode(darkTramIcon) },
  [TransportMode.ferry]: { square: DataUrlHelper.encode(darkFerryIconSquare), default: DataUrlHelper.encode(darkFerryIcon) },
  [TransportMode.taxi]: { square: DataUrlHelper.encode(darkTaxiIconSquare), default: DataUrlHelper.encode(darkTaxiIcon) },
  [TransportMode.walk]: { square: DataUrlHelper.encode(darkWalkIconSquare), default: DataUrlHelper.encode(darkWalkIcon) },
  [TransportMode.bike]: { square: DataUrlHelper.encode(darkBikeIconSquare), default: DataUrlHelper.encode(darkBikeIcon) },
};

function getImageSource(transportMode: TransportMode, renderAsSquare?: boolean): string {
  const sources = iconSources[transportMode];
  if (!sources) return '';
  return renderAsSquare ? sources.square : sources.default;
}

function TransportModeIcon({ transportMode, overrideAltText, renderAsSquare, className }: { transportMode: TransportMode; overrideAltText?: string; renderAsSquare?: boolean; className: string }) {
  const altText = overrideAltText !== undefined ? overrideAltText : TransportModeHelper.translate(transportMode);

  return <img className={className} src={getImageSource(transportMode, renderAsSquare)} alt={altText} />;
}

export default TransportModeIcon;
